import Axios from "axios"
import { useState, useEffect } from "react"
import Pagination from "../components-contabilidad-analisis/Pagination"
import { classNames } from "../tools/ClassNames"

const params = {
  "Opcion": "5",
  "FIni": "",
  "FFin": ""
}

export default function EdoCuenta({ url, headers, setLoadingAPIS }) {

  const [rawData, setRawData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios({
          method: 'GET',
          url: url,
          headers: headers,
          params: params
        })
        setRawData(response.data)
        setLoadingAPIS(curr => ({...curr, EdoCuenta: true}))
        
      } catch (err) {
        console.log(err)
      }
    }
    
    fetchData()
  }, [])

  const data = dataFormatter(rawData)

  //Paginación
  const [currentPage, setCurrentPage] = useState(1)
  const recordsPerPage = 3

  const indexOfLastRecord = currentPage * recordsPerPage
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage

  const currentRecords = data.slice(indexOfFirstRecord, indexOfLastRecord)

  const nPages = Math.ceil(data.length / recordsPerPage)
  //Fin paginación

  return (
    <div className="min-h-132">
      <div className="sm:flex sm:items-center">
        <div className='bg-primarioMira rounded-lg p-5'>
          <h3 className="text-lg font-medium leading-6 text-white">Cuentas bancarias</h3>
          <p className="mt-1 text-sm text-grisMira">Información de actualizaciones</p>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="-my-2 -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="inline-block w-full lg:py-2 align-middle lg:px-8">
            <div className="overflow-x-auto shadow ring-1 ring-black ring-opacity-5 rounded-t-lg">
              <table className="w-full divide-y divide-grisMira">
                <thead className="bg-primarioMira">
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-6">
                      Banco / No. cuenta
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                      Empresa
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                      Fecha última actualización
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                      Usuario
                    </th>
                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6 text-left text-sm font-semibold text-white">
                      Días sin actualizar
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-primarioMira">
                  {currentRecords.map((x, index) => (
                    <tr key={index}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                        <div className="flex items-center">
                          <div className="h-14 w-14 flex-shrink-0">
                            <img className="h-14 w-14 rounded-full" src={x.imageURL} alt="" />
                          </div>
                          <div className="ml-4">
                            <div className="font-medium text-white">{x.Banco}</div>
                            <div className="text-grisMira">{x.NoCuenta}</div>
                          </div>
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <div className="text-grisMira">{x.Empresa}</div>
                        {/*<div className="text-white">{x.department}</div>*/}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span className={classNames(
                          x.FecCargoEstadoCta !== '' ? 'bg-green-200/80 text-green-800' : 'bg-red-300/80 text-red-800',
                          '/inline-flex rounded-full px-8 py-1 w-full lg:w-3/4 leading-5 text-sm font-bold  flex place-content-center'
                        )}>
                          {x.FecCargoEstadoCta !== '' ? x.FecCargoEstadoCta : 'Sin Edo. Cuenta'}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-white">
                        {x.UsuarioCargoEstadoCta}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <p className="bg-green-200/80 /inline-flex rounded-full px-4 py-1 w-full lg:w-3/4 leading-5 text-sm text-green-800 font-bold flex place-content-center">
                          {x.DiasTrans}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalRecords={data.length}
        indexOfFirstRecord={indexOfFirstRecord}
        indexOfLastRecord={indexOfLastRecord}
      />
    </div >
  )
}

const dataFormatter = (arr) => {
  
  arr.map(obj => {
    switch (obj.Banco) {
      case 'Interbanco':
        obj.imageURL = './img/logos_bancos/Interbanco.PNG'
        break
      case 'BAC Credomatic':
        obj.imageURL = './img/logos_bancos/Bac.png'
        break
      case 'Reformador':
        obj.imageURL = './img/logos_bancos/Bac.png'
        break
        case 'Bam':
          obj.imageURL = './img/logos_bancos/Bam.jpg'
          break
      case 'Banrural':
        obj.imageURL = './img/logos_bancos/Banrural.PNG'
        break
        case 'Agromercantil':
          obj.imageURL = './img/logos_bancos/Bam.jpg'
          break
      default:
        break
    }
  })

  return arr

}